var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "140px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "storeFeedback.report.reportNo"
                                      ),
                                      prop: "reportNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.reportNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "reportNo",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "queryCondition.reportNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "storeFeedback.report.reportType"
                                      ),
                                      prop: "reportType",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        table: "TT_FEEDBACK_REPORT",
                                        field: "REPORT_TYPE",
                                      },
                                      model: {
                                        value: _vm.queryCondition.reportType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "reportType",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.reportType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("storeFeedback.storeNo"),
                                      prop: "storeNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.storeNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "storeNo",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "queryCondition.storeNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("storeFeedback.storeName"),
                                      prop: "storeName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.storeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "storeName",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "queryCondition.storeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.dcName"
                                              ),
                                              prop: "tmDcId",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "table-fields": [
                                                  {
                                                    table: "BASE",
                                                    field: "DC",
                                                  },
                                                  {
                                                    table: "TT_FEEDBACK",
                                                    field: "DIRECT_SUPPLIER",
                                                  },
                                                ],
                                                filterable: "",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.tmDcId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "tmDcId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.tmDcId",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.supplier"
                                              ),
                                              prop: "tmSupplierId",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "BASE",
                                                field: "PLANT",
                                                filterable: "",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .tmSupplierId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "tmSupplierId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.tmSupplierId",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.materialCode"
                                              ),
                                              prop: "materialCode",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .materialCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "materialCode",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.materialCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.materialName"
                                              ),
                                              prop: "materialName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .materialName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "materialName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.materialName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.feedbackChannel"
                                              ),
                                              prop: "sourceCode",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                table: "TT_FEEDBACK",
                                                field: "SOURCE_CODE",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.sourceCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "sourceCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.sourceCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.consumeType"
                                              ),
                                              prop: "consumeType",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                table: "TT_FEEDBACK",
                                                field: "CONSUME_TYPE",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .consumeType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "consumeType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.consumeType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.isDirectSale"
                                              ),
                                              prop: "isDirectSale",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                options: {
                                                  Y: _vm.$t("common.yes"),
                                                  N: _vm.$t("common.no"),
                                                },
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .isDirectSale,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "isDirectSale",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.isDirectSale",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "storeFeedback.report.doubtCommunicationStatus"
                                              ),
                                              prop: "answerStatus",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                excludes: ["STORE_SAVE"],
                                                table: "TT_FEEDBACK_REPORT",
                                                field: "QUESTION_STATUS",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .answerStatus,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "answerStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.answerStatus",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.restQueryForm()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.reset")))]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            ref: "table",
            staticClass: "table",
            attrs: {
              data: _vm.tableData,
              border: "",
              "highlight-current-row": "",
              "max-height": "420",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                fixed: "",
                prop: "reportNo",
                label: _vm.$t("storeFeedback.report.reportNo"),
                "min-width": "200",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "a-link",
                          on: {
                            click: function ($event) {
                              return _vm.toDetail(scope.row.ttFeedbackReportId)
                            },
                          },
                        },
                        [_vm._v(_vm._s(scope.row.reportNo))]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "100",
                prop: "reportType",
                label: _vm.$t("storeFeedback.report.reportType"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.reportType,
                            "TT_FEEDBACK_REPORT",
                            "REPORT_TYPE"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "120",
                prop: "storeNo",
                label: _vm.$t("storeFeedback.storeNo"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "140",
                prop: "storeName",
                label: _vm.$t("storeFeedback.storeName"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "80",
                prop: "tmDcId",
                label: _vm.$t("storeFeedback.dcName"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(_vm._f("ic")(scope.row.tmDcId, "BASE", "DC"))
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "80",
                prop: "materialCode",
                label: _vm.$t("storeFeedback.materialCode"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "130",
                prop: "materialName",
                label: _vm.$t("storeFeedback.materialName"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "100",
                prop: "tmSupplierId",
                label: _vm.$t("storeFeedback.supplier"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(scope.row.tmSupplierId, "BASE", "PLANT")
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "80",
                prop: "sourceCode",
                label: _vm.$t("storeFeedback.feedbackChannel"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.sourceCode,
                            "TT_FEEDBACK",
                            "SOURCE_CODE"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "70",
                prop: "consumeType",
                label: _vm.$t("storeFeedback.consumeType"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.consumeType,
                            "TT_FEEDBACK",
                            "CONSUME_TYPE"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "70",
                formatter: _vm.formatterYesNo,
                prop: "isDirectSale",
                label: _vm.$t("storeFeedback.isDirectSale"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                "min-width": "90",
                prop: "status",
                label: _vm.$t("storeFeedback.report.doubtCommunicationStatus"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.answerStatus,
                            "TT_FEEDBACK_REPORT",
                            "QUESTION_STATUS"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }